import { Search, Download, FileCheck2, FileWarning, Sparkles } from "lucide-react";
import { csvExportUrl } from "@/lib/api";

const FILTER_OPTIONS = [
  { label: "All", code: "" },
  { label: "01 Fatal", code: "01" },
  { label: "02 Serious", code: "02" },
  { label: "03 Minor", code: "03" },
  { label: "04 + Amb", code: "04" },
  { label: "04 No Amb", code: "04nt" },
];

export default function ReportFilters({
  jobId,
  search,
  setSearch,
  injuryFilter,
  setInjuryFilter,
  reportsCount,
  qualifyingCount,
  failedCount,
  skippedCount,
  onOpenFailed,
  reEnrichCount = 0,
  onReEnrich,
  reEnriching = false,
}) {
  return (
    <section className="flex flex-wrap items-center gap-3 border-t border-black/10 pt-6">
      <div className="flex items-center gap-2 border border-black px-2 py-1.5 bg-white w-full md:w-80">
        <Search className="w-4 h-4 opacity-60" />
        <input
          data-testid="search-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search name or filename…"
          className="font-mono text-[12px] bg-transparent outline-none w-full"
        />
      </div>
      <div className="inline-flex border border-black">
        {FILTER_OPTIONS.map((opt) => (
          <button
            key={opt.code || "all"}
            data-testid={`filter-${opt.code || "all"}`}
            onClick={() => setInjuryFilter(opt.code)}
            className={
              "font-mono text-[11px] uppercase tracking-[0.18em] px-3 py-1.5 border-l border-black first:border-l-0 " +
              (injuryFilter === opt.code ? "bg-black text-white" : "bg-white hover:bg-zinc-100")
            }
          >
            {opt.label}
          </button>
        ))}
      </div>
      <div className="ml-auto flex items-center gap-3">
        {reEnrichCount > 0 && jobId && (
          <button
            data-testid="re-enrich-btn"
            onClick={onReEnrich}
            disabled={reEnriching}
            className="inline-flex items-center gap-1 border border-black bg-white px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.18em] hover:bg-black hover:text-white disabled:opacity-40"
            title="Re-run AI extraction on qualifying reports missing narrative / fault / insurance data (uses AI credits)."
          >
            <Sparkles className="w-3.5 h-3.5" /> Re-enrich {reEnrichCount}
          </button>
        )}
        {qualifyingCount > 0 && jobId && (
          <a
            data-testid="export-csv-btn"
            href={csvExportUrl(jobId)}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = csvExportUrl(jobId);
            }}
            className="inline-flex items-center gap-1 border border-black bg-black text-white px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.18em] hover:bg-zinc-800 cursor-pointer no-underline"
            title="Download CSV of every qualifying person"
          >
            <Download className="w-3.5 h-3.5" /> Export CSV
          </a>
        )}
        <div className="font-mono text-[11px] uppercase tracking-[0.2em] opacity-70 inline-flex items-center gap-3 flex-wrap">
          <span className="inline-flex items-center gap-2">
            <FileCheck2 className="w-4 h-4" /> {reportsCount} matching
          </span>
          {skippedCount > 0 && (
            <span
              data-testid="skipped-count"
              title="Reports we extracted but where no one had a qualifying injury (codes 01/02/03/04). Hidden from the main view but counted here so nothing seems missing."
              className="inline-flex items-center gap-1 opacity-60"
            >
              {skippedCount} no-injury (hidden)
            </span>
          )}
          {failedCount > 0 && (
            <button
              data-testid="open-failed-modal"
              onClick={onOpenFailed}
              className="inline-flex items-center gap-1 text-red-600 hover:underline cursor-pointer font-mono text-[11px] uppercase tracking-[0.2em]"
              title="Click to see which files failed"
            >
              <FileWarning className="w-4 h-4" /> {failedCount} failed
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
